import { useFormikContext } from "formik";
import {
  DisplayFormErrors,
  DrawerFooterContent,
  InputField,
  SelectField,
  useCultures,
  VerticalForm,
} from "melco-shared-logic";
import { Button, Row, Title } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

type DisplayChangeMachineLicensesFormProps = {
  //callback:(v:any)=> any
};
const AlertWrapper = styled.div`
  margin-top: 25px;
`;

export const DisplayChangeMachineLicensesForm: React.FC<
  DisplayChangeMachineLicensesFormProps
> = ({ }) => {
  const { t } = useTranslation();
  const { cultures } = useCultures();
  const { submitForm } = useFormikContext();

  return (
    <>
      <div>
        <Title level={4}>
          {t("machinelicenses.change.steps.checklicense")}
        </Title>
        <VerticalForm>
          <AlertWrapper>
            <DisplayFormErrors />
          </AlertWrapper>

          <InputField
            name="email_address"
            label={t("machinelicenses.change.form.notification_email_address")}
            info={t("machinelicenses.change.form.notification_email_address_info")}
          />
          <InputField
            name="transaction_id"
            label={t("machinelicenses.change.form.transaction_id")}
          />
          <SelectField
            name="language"
            label={t("machinelicenses.change.form.language")}
            options={cultures.map((culture) => {
              return {
                label: culture.name,
                value: culture.code,
              };
            })}
            showSearch
            optionFilterProp="label"
            info={t("machinelicenses.change.form.language_info")}
          // onChange={(value: string, obj: DropDownValueLabelObj) => {
          //   callBackForLanguage(value, obj);
          // }}
          />

          <DrawerFooterContent>
            <Row justify="end">
              <Button
                style={{ minWidth: "80px" }}
                key="add-user-button"
                type="primary"
                onClick={() => {
                  //callback(createConfirmDetailsToDisplay);
                  submitForm();
                }}
              >
                {t("machinelicenses.buttons.next")}
              </Button>
            </Row>
          </DrawerFooterContent>
        </VerticalForm>
      </div>
    </>
  );
};
